import {TableData} from "../../../shared/ui/table/models/TableProps";

export const tableStructureEmployees: TableData[] = [
    {
        name: "surname",
        label: "Cognome",
    },
    {
        name: "name",
        label: "Nome",
    },
    {
        name: "color",
        label: "Colore",
    },
    {
        name: "type",
        label: "Tipo Utente",
    },
    {
        name: "email",
        label: "Email",
    },
    {
        name: "action",
        label: "",
    },
];
